export default (window.location.hostname.indexOf('test') != -1) ? "test" : "production";



// WEBPACK FOOTER //
// ./src/devices/all/env.js